import React, { useEffect } from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import styles from "./FullScreen.module.scss";

function FullScreen({ children, isSearchPage }) {
  useEffect(() => {
    Object.assign(document.body.style, {
      overflow: "hidden",
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    });

    return () => {
      Object.assign(document.body.style, {
        overflow: "inherit",
        position: "inherit",
        top: "inherit",
        right: "inherit",
        bottom: "inherit",
        left: "inherit",
      });
    };
  });

  const fulllScreenClass = () =>
    classnames(styles.fullscreen, isSearchPage && styles["fullscreen--search"]);

  return <div className={fulllScreenClass()}>{children}</div>;
}

FullScreen.propTypes = {
  isSearchPage: PropTypes.bool,
};

FullScreen.defaultProps = {
  isSearchPage: false,
};

export default FullScreen;
